import "core-js/modules/es.array.for-each";
import "core-js/modules/web.dom-collections.for-each";
import { __awaiter, __generator } from "tslib";
import Vue from 'vue';
var m = {
  namespaced: true,
  state: {
    rank: {}
  },
  mutations: {
    initRank: function initRank(state, _a) {
      var key = _a.key;
      Vue.set(state.rank, key, {
        list: [],
        loaded: false,
        req: false,
        self: null,
        cold_time: null
      });
    },
    setRank: function setRank(state, _a) {
      var key = _a.key,
          list = _a.list,
          offset = _a.offset;
      list.forEach(function (ele, idx) {
        Vue.set(state.rank[key].list, offset + idx, ele);
      });
    },
    setReq: function setReq(state, _a) {
      var key = _a.key,
          req = _a.req;
      state.rank[key].req = req;
    },
    setLoaded: function setLoaded(state, _a) {
      var key = _a.key,
          loaded = _a.loaded;
      state.rank[key].loaded = loaded;
    },
    setSelf: function setSelf(state, _a) {
      var key = _a.key,
          self = _a.self,
          cold_time = _a.cold_time;
      state.rank[key].self = self;
      state.rank[key].cold_time = cold_time;
    }
  },
  actions: {
    getRanks: function getRanks(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var key = _b.key,
          offset = _b.offset,
          count = _b.count,
          activityId = _b.activityId,
          type = _b.type,
          forceUpdate = _b.forceUpdate;
      return __awaiter(this, void 0, void 0, function () {
        var wrap, res, rdata, list;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              wrap = state.rank[key];

              if (!wrap || forceUpdate && offset === 0) {
                commit('initRank', {
                  key: key
                });
                wrap = state.rank[key];
              }

              if (wrap.loaded || wrap.req) {
                return [2
                /*return*/
                ];
              }

              commit('setReq', {
                key: key,
                req: true
              });
              return [4
              /*yield*/
              , Vue.axios.get("/api/v1/activity_match_rank/" + type, {
                params: {
                  activity_id: activityId,
                  offset: offset,
                  count: count
                }
              })];

            case 1:
              res = _c.sent();
              commit('setReq', {
                key: key,
                req: false
              });
              rdata = res.data;

              if (rdata.status === 0) {
                list = rdata.data.list;
                commit('setRank', {
                  offset: offset,
                  list: list,
                  key: key
                });
                commit('setSelf', {
                  key: key,
                  self: rdata.data.self,
                  cold_time: rdata.data.cold_time
                });

                if (list.length < count) {
                  commit('setLoaded', {
                    key: key,
                    loaded: true
                  });
                }
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    }
  }
};
export default m;